'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleEventMessage = undefined;

var _trafficManager = require('./traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

var _livePersonManager = require('./live-person-manager');

var _livePersonManager2 = _interopRequireDefault(_livePersonManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var escalateEvent = 'escalate';

/**
 * Handles Events
 *
 * @param {Object} eventMessage The event Message.
 * @param {Object} helpBot The help Bot Object.
 * @private
 */
var handleEventMessage = exports.handleEventMessage = function handleEventMessage(eventMessage, helpBot) {
  if (!eventMessage.msg.payload.fields.name) {
    return;
  }
  var eventName = eventMessage.msg.payload.fields.name.stringValue;

  _trafficManager2.default.sendBotActionEvent('cx.help-bot.bot.event', eventMessage.intent, eventMessage.sessionId, eventName);
  if (eventName.indexOf(escalateEvent) === 0) {
    _livePersonManager2.default.sendConversationToCRM(helpBot.state.chatbotsApiBaseUrl);
  }
  helpBot.triggerEvent(eventName);
};

exports.default = {
  handleEventMessage: handleEventMessage
};